export default __webpack_public_path__ + "static/media/group-chat-grid.f65eb6c2.svg";